import { shapeEntity } from '../shapeEntity';
import fieldCropState from './fieldCrop.state';
import fieldCropApi, { fieldCropApiInstance } from './fieldCrop.api';

export default shapeEntity('FieldCrop', {
    useState: fieldCropState,
    ...fieldCropApi,
    api: fieldCropApiInstance,
});
